import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import '../KycComponent/kyc.css';
import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { store } from "../../redux/store";
import { setPersonalInfo, setSaveData } from "../../redux/retailer-kyc-details/retailer-kyc-details.action";
import { Link } from "react-router-dom";
import HeaderCommon from '../HeaderComponent/HeadeCommon';
import Menu from "../MenuComponent/Menu";
import tokenErrorHandler from "../tokenErrorHandler";
import { setIfscCode, setSelectedBankName } from "../../redux/misc-data/misc-data.action";
// import { responseInterceptor } from "http-proxy-middleware";
// const httpClient = axios.create();
class UploadMerchantId extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadErrorMessage: '',
            docs: [],
            panUploadErrMsg: '',
            panUplodMsg: '',
            aadhaarUploadErrMsg: '',
            aadhaarUploadMsg: '',
            passbookUploadErrMsg: '',
            passbookUploadMsg: '',
            frontUploadErrMsg: '',
            backUploadErrMsg: '',
            saveDataErr: '',
            progress: '',
            docTypeList: [
                { value: "Select", label: "Select" },
                { value: "PAN", label: "PAN" }
            ],
            selectedDocType: '',
            selectedDocList: [],
            errorMsg: '',
            passBookErr: '',
            panErr: '',
            frontErr: '',
            backErr: '',
            panselectedFile: null,
            passselectedFile: null,
            frontselectedFile: null,
            backselectedFile: null,
        }
    }


    componentDidMount() {

        store.dispatch(setSelectedBankName(''));
        store.dispatch(setIfscCode(''));
    }
    componentWillUnmount() {
    }


    docTypeSelect = (event) => {
        if (event.target.value == 'Select') {
            alert('Please select a document type');

        } else {
            this.setState({
                selectedDocType: event.target.value,
                selectedDocList: [],
                panselectedFile: null,
                passselectedFile: null,
                frontselectedFile: null,
                backselectedFile: null,
                panUploadErrMsg: '',
                panUplodMsg: '',
                aadhaarUploadErrMsg: '',
                aadhaarUploadMsg: '',
                passbookUploadErrMsg: '',
                passbookUploadMsg: '',
                frontUploadErrMsg: '',
                backUploadErrMsg: '',
                passBookErr: '',
                panErr: '',
                frontErr: '',
                backErr: '',
                errorMsg: ''

            })

        }
    }


    dropHandler = (ev) => {
        console.log('File(s) dropped');
        ev.preventDefault();
        if (ev.dataTransfer.items) {
            for (var i = 0; i < ev.dataTransfer.items.length; i++) {
                if (ev.dataTransfer.items[i].kind === 'file') {
                    var file = ev.dataTransfer.items[i].getAsFile();
                    console.log('... file[' + i + '].name = ' + file.name);
                }
            }
        } else {
            for (var i = 0; i < ev.dataTransfer.files.length; i++) {
                console.log('... file[' + i + '].name = ' + ev.dataTransfer.files[i].name);
            }
        }
    }
    dragOverHandler = (ev) => {
        console.log('File(s) in drop zone');
        ev.preventDefault();
    }

    uploadDoc = (event, type) => {
        if (type == 'PAN') {
            this.setState({
                panUploadErrMsg: '',
                panUplodMsg: '',
                panErr: ''
            })
        }
        if (type == 'Aadhaar-frontIage') {
            this.setState({
                frontUploadErrMsg: '',
                aadhaarUploadMsg: '',
                frontErr: ''
            })
        }
        if (type == 'Aadhaar-backImage') {
            this.setState({
                backUploadErrMsg: '',
                aadhaarUploadMsg: '',
                backErr: ''
            })
        }
        if (type == 'PASSBOOK') {
            this.setState({
                passbookUploadErrMsg: '',
                passbookUploadMsg: '',
                passBookErr: ''
            })
        }


        if (event != null) {
            if (event.target != null) {
                console.log('event.....' + JSON.stringify(event.target.files[0].type));
                if (event.target.files[0].type.includes("image/jpeg")
                    // || event.target.files[0].type.includes("image/gif")
                    // || event.target.files[0].type.includes("image/png")
                    // || event.target.files[0].type.includes("image/jpg")


                ) {
                    var filesize = process.env.REACT_APP_PAYOUTFILESIZE;
                    // alert('filesize in kb:' + filesize * 1024)
                    if (parseInt(event.target.files[0].size / 1000) < filesize * 1024) {

                        if (event.target.files[0] != null) {

                            console.log('event.target.files[0]' + URL.createObjectURL(event.target.files[0]));


                            // var fileV=event.target.files[0];

                            var file = event.target.files[0];
                            var blob = file.slice(0, file.size, 'image/jpeg');
                            var newFile = Object;

                            if (type == 'PAN') {
                                newFile = new File([blob], 'panimage' + "_" + this.props.agentInfo.id + ".jpg", { type: 'image/jpeg' });
                                this.setState({
                                    panselectedFile: URL.createObjectURL(event.target.files[0])
                                });
                            }

                            if (type == 'Aadhaar-frontIage') {
                                newFile = new File([blob], 'front_image' + "_" + this.props.agentInfo.id + ".jpg", { type: 'image/jpeg' });
                                this.setState({
                                    frontselectedFile: URL.createObjectURL(event.target.files[0])
                                });
                            }
                            if (type == 'Aadhaar-backImage') {
                                newFile = new File([blob], 'back_image' + "_" + this.props.agentInfo.id + ".jpg", { type: 'image/jpeg' });
                                this.setState({
                                    backselectedFile: URL.createObjectURL(event.target.files[0])
                                });
                            }
                            if (type == 'PASSBOOK') {
                                newFile = new File([blob], 'passbook' + "_" + this.props.agentInfo.id + ".jpg", { type: 'image/jpeg' });
                                this.setState({
                                    passselectedFile: URL.createObjectURL(event.target.files[0])
                                });
                            }
                            //Aadhaar-frontIage



                            var selectedDocList = this.state.selectedDocList;

                            var selectedFileNameList = [];

                            if (selectedDocList.length > 0) {

                                selectedDocList.map(selectedDoc => {
                                    selectedFileNameList.push(selectedDoc.name)


                                })
                                if (selectedFileNameList.includes(newFile.name)) {
                                    selectedDocList.map(selectedDoc => {
                                        if (selectedDoc.name == newFile.name) {
                                            selectedDoc = newFile;
                                        }
                                    })
                                } else {
                                    selectedDocList.push(newFile)
                                }

                            } else {
                                selectedDocList.push(newFile)
                            }

                            this.setState({
                                selectedDocList: selectedDocList
                            })

                        }
                    } else {
                        alert("Image size must be less tahn or equal " + filesize + " MB.");
                    }

                } else {
                    console.log("file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported");
                    if (type == 'PAN') {
                        this.setState({
                            panUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'Aadhaar') {
                        this.setState({
                            aadhaarUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'PASSBOOK') {
                        this.setState({
                            passbookUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'Aadhaar-frontIage') {
                        this.setState({
                            frontUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    } else if (type == 'Aadhaar-backImage') {
                        this.setState({
                            backUploadErrMsg: "file type is::" + event.target.files[0].type + " only .jpg,.png, .gif,.pdf supported"
                        })
                    }

                }
            }
        }
    }

    uploadAlldocsValidation = (event) => {
        event.preventDefault();



        this.setState({
            passBookErr: '',
            panErr: '',
            frontErr: '',
            backErr: '',
        })

        var fileNameList = [];
        var passbookImageAvailable = true;
        var panImageAvailable = true;
        var frontImageAvailable = true;
        var backImageAvailable = true;



        if (this.state.selectedDocList.length > 0) {
            this.state.selectedDocList.map(fileNames => {
                fileNameList.push(fileNames.name.toLowerCase());

            })
        }


        if (fileNameList.includes('passbook' + "_" + this.props.agentInfo.id + ".jpg")) {
            passbookImageAvailable = true;
        } else {
            passbookImageAvailable = false;
        }

        if (this.state.selectedDocType == 'PAN') {
            if (fileNameList.includes('panimage' + "_" + this.props.agentInfo.id + ".jpg")) {
                panImageAvailable = true;
            } else {
                panImageAvailable = false;
            }
        }
        if (this.state.selectedDocType == 'AADHAAR') {
            if (fileNameList.includes('front_image' + "_" + this.props.agentInfo.id + ".jpg")) {
                frontImageAvailable = true;
            } else {
                frontImageAvailable = false;
            }
            if (fileNameList.includes('back_image' + "_" + this.props.agentInfo.id + ".jpg")) {
                backImageAvailable = true;
            } else {
                backImageAvailable = false;
            }
        }


        if (this.state.selectedDocType == 'PAN') {

            if (passbookImageAvailable == true &&
                panImageAvailable == true) {
                this.uploadAllDocs();
            } else {
                if (passbookImageAvailable == false) {
                    this.setState({
                        passBookErr: 'Please upload PASSBOOK'
                    })
                }
                if (panImageAvailable == false) {
                    this.setState({
                        panErr: 'Please upload PAN'
                    })
                }
            }
        }
        if (this.state.selectedDocType == 'AADHAAR') {
            if (passbookImageAvailable == true &&
                frontImageAvailable == true &&
                backImageAvailable == true) {
                this.uploadAllDocs();
            } else {
                if (passbookImageAvailable == false) {
                    this.setState({
                        passBookErr: 'Please upload PASSBOOK'
                    })
                }
                if (frontImageAvailable == false) {
                    this.setState({
                        frontErr: 'Please upload Front Image of Aadhar'
                    })
                }
                if (backImageAvailable == false) {
                    this.setState({
                        backErr: 'Please upload Back Image of Aadhar'
                    })
                }
            }
        }

    }


    // async  loadGames() {
    //     try {
    //       const response = await fetchWithTimeout('/games', {
    //         timeout: 6000
    //       });
    //       const games = await response.json();
    //       return games;
    //     } catch (error) {
    //       // Timeouts if the request takes
    //       // longer than 6 seconds
    //       console.log(error.name === 'AbortError');
    //     }
    //   }

    //   async  fetchWithTimeout(resource, options = {}) {
    //     const { timeout = 8000 } = options;

    //     const controller = new AbortController();
    //     const id = setTimeout(() => controller.abort(), timeout);
    //     const response = await fetch(resource, {
    //       ...options,
    //       signal: controller.signal  
    //     });
    //     clearTimeout(id);
    //     return response;
    //   }

    parseJson = response => {

        const text = response;
        try {
            const json = JSON.parse(text)
            alert('json:' + json);
            return json
        } catch (err) {
            this.setState({
                progress: 'completed',
                errorMsg: response
            })
            return undefined
            // throw new Error("Did not receive JSON, instead received: " + text)
        }
    }

    // async parseJson = (text1) => {

    //     try {

    //         const json = await JSON.parse(text1);
    //         alert(json)
    //         return json
    //     } catch (err) {
    //         this.setState({
    //             progress: 'completed',
    //             errorMsg: text1
    //         })
    //         return undefined


    //         //alert("Did not receive JSON, instead received: " + text1)
    //     }
    // }


    uploadAllDocs = () => {


        this.setState({
            progress: 'loading',
            errorMsg: ''
        })


        const formData = new FormData();

        this.state.selectedDocList.map(fileNames => {

            formData.append(
                "documents", fileNames
            );
        })


        formData.append(
            "doctype", this.state.selectedDocType
        );
        formData.append(
            "merchantCode", this.props.agentInfo.id

        );

        formData.append(
            "token", this.props.token
        );
        const headers = {
            'Authorization': 'Bearer ' + this.props.token,
            'client-id': this.props.agentInfo.id
            , 'role': this.props.clientRole,
            // 'Content-Type': 'application/json',
            Accept: 'application/json'

        }

        //var html1 = <html><body><div>Test value</div></body></html>;
        // alert(typeof html1);

        //var res1 = '';



        fetch('/api/v1/payout/connector/upload', {
            method: 'post',
            body: formData,
            headers: headers,
            options: {
                timeout: 120000,
            }
        })

            .then(promise => promise.text())
            //.catch(res=>this.parseJson(res))

            .then(text => {


                try {
                    const data = JSON.parse(text);
                    // const data = JSON.parse(text); // Try to parse the response as JSON
                    // if (data != undefined) {
                    //     if (data.response != undefined) {
                    //         if (data.response.msg != undefined) {
                    if (data.response.msg == 'SUCCESS') {

                        this.setState({
                            progress: 'completed',
                            errorMsg: ''
                        })
                        var gotoMerchantPayoutPage =
                            document.getElementById('gotoMerchantPayoutPage');
                        gotoMerchantPayoutPage.click();
                    } else {
                        this.setState({
                            progress: 'completed',
                            errorMsg: data.response.displayMsg
                        })
                    }
                    // } else {
                    //     this.setState({
                    //         progress: 'completed',
                    //         errorMsg: data.response
                    //     })
                    // }
                    // } else {

                    //     alert('here1')
                    //     this.setState({
                    //         progress: 'completed',
                    //         errorMsg: data.message != undefined ? data.message : data
                    //     })
                    // }
                    // } else {
                    //     alert('here2')
                    //     this.setState({
                    //         progress: 'completed',
                    //         errorMsg: 'response is undefined'
                    //     })
                    // }
                } catch (err) {
                    this.setState({
                        progress: 'completed',
                        errorMsg: text + ' ' + err.message
                    })
                }




            }).catch(errorx => {
                // alert('here3')
                // alert(errorx)
                this.setState({
                    progress: 'completed',
                    errorMsg: errorx.message
                })

                // console.log('file upload error..' + errorx);
            });
    }

    removeImage = (event, type) => {
        console.log('removeImage');

        if (type == 'PAN') {
            this.setState({
                panselectedFile: null
            })
        }

        if (type == 'front_image') {
            this.setState({
                frontselectedFile: null
            })
        }
        if (type == 'back_image') {
            this.setState({
                backselectedFile: null
            })
        }
        if (type == 'PASSBOOK') {
            this.setState({
                passselectedFile: null
            })
        }


    }












    render() {

        console.log(JSON.stringify(this.props.personalInfo))
        return (
            <div>
                <HeaderCommon />
                <Menu />
                <div class="mid-contant">
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <div class="main-heading">
                                    <h2>Upload merchant Id proof</h2>
                                </div>
                                <Link to='/merchant-payout'>
                                    <button id='gotoMerchantPayoutPage' hidden={true}></button>
                                </Link>
                            </div>

                            <div class="col-12">
                                <div class="registerbox">
                                    <div class="row mb-3">
                                        <div class="col-12 col-lg-7">
                                            <form onSubmit={this.uploadAlldocsValidation}>
                                                <div class="row">

                                                    <div class="filters">
                                                        <label for="status">Document Type:</label>


                                                        <select class="form-select" id="status"
                                                            aria-label=""
                                                            onChange={this.docTypeSelect} required>

                                                            {this.state.docTypeList.map(docType => (
                                                                <option value={docType.value}
                                                                >{docType.label}</option>
                                                            ))}

                                                        </select>
                                                    </div>
                                                    <div class="col-12">
                                                        < br />
                                                    </div>

                                                    <div class="col-12">
                                                        <div class="formnote">Upload PASSBOOK</div>
                                                    </div>


                                                    <div class="col-12">
                                                        {this.state.passBookErr != '' &&
                                                            <div class="valid-error">
                                                                {this.state.passBookErr}
                                                            </div>}
                                                        <div class="file-upload">
                                                            <div class="dropzone-wrapper">
                                                                <div class="dropzone-desc">
                                                                    <i class="camera"></i>
                                                                    <h6>Upload PASSBOOK</h6>
                                                                </div>
                                                                <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                </div>
                                                                <input type="file" name="fileup" class="dropzone"
                                                                    onChange={e => this.uploadDoc(e, 'PASSBOOK')} />
                                                            </div>
                                                            {/* {this.state.panUrl != '' &&
                                                                    <img src={this.state.panUrl} alt="Oxigen" class="img-fluid" />
                                                                } */}
                                                            {this.state.passbookUploadMsg != '' &&
                                                                <div class="valid-success">
                                                                    {this.state.passbookUploadMsg}
                                                                </div>}
                                                            {this.state.passbookUploadErrMsg != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.passbookUploadErrMsg}
                                                                </div>}

                                                            {this.state.passselectedFile &&
                                                                <div class="preview-zone">
                                                                    <div class="box">
                                                                        {/* <div class="progress" style={{ height: 6 + "px" }}>
                                                                            <div class="progress-bar" role="progressbar"
                                                                                style={{ width: this.state.progress + "%" }}
                                                                                aria-valuenow="25" aria-valuemin="0"
                                                                                aria-valuemax="100"></div>
                                                                        </div> */}
                                                                        <div class="box-body"></div>
                                                                        <img src={this.state.passselectedFile} alt="" width="100" />
                                                                        {/* <button type="button" class="remove-preview" onClick={e => this.removeImage(e, 'PASSBOOK')}> Remove</button> */}
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                    {this.state.selectedDocType == 'PAN' &&
                                                        <div class="col-12">
                                                            <div class="formnote">Upload PAN</div>
                                                        </div>
                                                    }
                                                    {this.state.selectedDocType == 'PAN' &&
                                                        <div class="col-12">
                                                            {this.state.panErr != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.panErr}
                                                                </div>}
                                                            <div class="file-upload">
                                                                <div class="dropzone-wrapper">
                                                                    <div class="dropzone-desc">
                                                                        <i class="camera"></i>
                                                                        <h6>Upload PAN</h6>
                                                                    </div>
                                                                    <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                    </div>
                                                                    <input type="file" name="fileup" class="dropzone"
                                                                        onChange={e => this.uploadDoc(e, 'PAN')} />
                                                                </div>
                                                                {/* {this.state.panUrl != '' &&
                                                                    <img src={this.state.panUrl} alt="Oxigen" class="img-fluid" />
                                                                } */}
                                                                {this.state.panUplodMsg != '' &&
                                                                    <div class="valid-success">
                                                                        {this.state.panUplodMsg}
                                                                    </div>}
                                                                {this.state.panUploadErrMsg != '' &&
                                                                    <div class="valid-error">
                                                                        {this.state.panUploadErrMsg}
                                                                    </div>}


                                                                {this.state.panselectedFile &&
                                                                    <div class="preview-zone">
                                                                        <div class="box">
                                                                            {/* <div class="progress" style={{ height: 6 + "px" }}>
                                                                                <div class="progress-bar" role="progressbar"
                                                                                    style={{ width: this.state.progress + "%" }}
                                                                                    aria-valuenow="25" aria-valuemin="0"
                                                                                    aria-valuemax="100"></div>
                                                                            </div> */}
                                                                            <div class="box-body"></div>
                                                                            <img src={this.state.panselectedFile} alt="" width="100" />
                                                                            {/* <button type="button" class="remove-preview" onClick={e => this.removeImage(e, 'PAN')}> Remove</button> */}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    }

                                                    {this.state.selectedDocType == 'AADHAAR' &&
                                                        <div class="col-12">
                                                            <div class="formnote">Upload Aadhaar card front side photo</div>
                                                        </div>
                                                    }

                                                    {this.state.selectedDocType == 'AADHAAR' &&
                                                        <div class="col-12">
                                                            {this.state.frontErr != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.frontErr}
                                                                </div>}
                                                            <div class="file-upload">
                                                                <div class="dropzone-wrapper">
                                                                    <div class="dropzone-desc">
                                                                        <i class="camera"></i>
                                                                        <h6>Upload Aadhaar Front Image</h6>
                                                                    </div>
                                                                    <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                    </div>
                                                                    <input type="file" name="fileup" class="dropzone"
                                                                        onChange={e => this.uploadDoc(e, 'Aadhaar-frontIage')} />

                                                                </div>
                                                                {/* {this.state.aadhaarUrl != '' &&
                                                                    <img src={this.state.aadhaarUrl} alt="Oxigen" class="img-fluid" />
                                                                } */}
                                                                {this.state.aadhaarUploadMsg != '' &&
                                                                    <div class="valid-success">
                                                                        {this.state.aadhaarUploadMsg}
                                                                    </div>}
                                                                {this.state.frontUploadErrMsg != '' &&
                                                                    <div class="valid-error">
                                                                        {this.state.frontUploadErrMsg}
                                                                    </div>}

                                                                {this.state.frontselectedFile &&
                                                                    <div class="preview-zone">
                                                                        <div class="box">
                                                                            {/* <div class="progress" style={{ height: 6 + "px" }}>
                                                                                <div class="progress-bar" role="progressbar"
                                                                                    style={{ width: this.state.progress + "%" }}
                                                                                    aria-valuenow="25" aria-valuemin="0"
                                                                                    aria-valuemax="100"></div>
                                                                            </div> */}
                                                                            <div class="box-body"></div>
                                                                            <img src={this.state.frontselectedFile} alt="" width="100" />
                                                                            {/* <button type="button" class="remove-preview" onClick={e => this.removeImage(e, 'front_image')}> Remove</button> */}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>

                                                        </div>
                                                    }


                                                    {this.state.selectedDocType == 'AADHAAR' &&
                                                        <div class="col-12">
                                                            <div class="formnote">Upload Aadhaar card back side photo</div>
                                                        </div>
                                                    }

                                                    {this.state.selectedDocType == 'AADHAAR' &&
                                                        <div class="col-12">
                                                            {this.state.backErr != '' &&
                                                                <div class="valid-error">
                                                                    {this.state.backErr}
                                                                </div>}
                                                            <div class="file-upload">
                                                                <div class="dropzone-wrapper">
                                                                    <div class="dropzone-desc">
                                                                        <i class="camera"></i>
                                                                        <h6>Upload Aadhaar Back Image</h6>
                                                                    </div>
                                                                    <div id="drop_zone" onDrop={this.dropHandler} onDrag={this.dragOverHandler}>
                                                                    </div>
                                                                    <input type="file" name="fileup" class="dropzone"
                                                                        onChange={e => this.uploadDoc(e, 'Aadhaar-backImage')} />

                                                                </div>
                                                                {/* {this.state.aadhaarUrl != '' &&
                                                                    <img src={this.state.aadhaarUrl} alt="Oxigen" class="img-fluid" />
                                                                } */}
                                                                {this.state.aadhaarUploadMsg != '' &&
                                                                    <div class="valid-success">
                                                                        {this.state.aadhaarUploadMsg}
                                                                    </div>}
                                                                {this.state.backUploadErrMsg != '' &&
                                                                    <div class="valid-error">
                                                                        {this.state.backUploadErrMsg}
                                                                    </div>}

                                                                {this.state.backselectedFile &&
                                                                    <div class="preview-zone">
                                                                        <div class="box">
                                                                            {/* <div class="progress" style={{ height: 6 + "px" }}>
                                                                                <div class="progress-bar" role="progressbar"
                                                                                    style={{ width: this.state.progress + "%" }}
                                                                                    aria-valuenow="25" aria-valuemin="0"
                                                                                    aria-valuemax="100"></div>
                                                                            </div> */}
                                                                            <div class="box-body"></div>
                                                                            <img src={this.state.backselectedFile} alt="" width="100" />
                                                                            {/* <button type="button" class="remove-preview" onClick={e => this.removeImage(e, 'back_image')}> Remove</button> */}
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </div>

                                                        </div>
                                                    }



                                                    {this.state.selectedDocType != '' &&
                                                        <div class="col-12">
                                                            <button type="submit" class="btn btn-primary" id="continue"
                                                                disabled={this.state.progress == 'loading' && true}
                                                            >Continue</button>
                                                        </div>
                                                    }
                                                    {this.state.errorMsg != '' &&
                                                        <div class='valid-error'>
                                                            {this.state.errorMsg}
                                                        </div>
                                                    }
                                                </div>
                                            </form>
                                        </div>


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                </div >
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone, agentInfo, token, clientRole, clientRequesterId, callBackUrl },
        retailerKycReduce: { registerRetailerResponse, personalInfo } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone, agentInfo, token, clientRole,
    clientRequesterId, callBackUrl, registerRetailerResponse, personalInfo
});

export default connect(mapStateToProps, null)(UploadMerchantId);
